// Copyright (c) 2017 Deere & Company

import {
    createErrorObject,
    errorAlertBar
} from '../../../shared/services/alert-bar';
import {
    mapClaimValidation,
    mapSearchRoutes,
    mapValidationErrorMessages
} from '../../../home-page/shared/services/home-page-helper';
import actions from '../../actions-list';
import {routerActions} from 'react-router-redux';
import {translate} from '../../../shared/services/translation-service';

export const updateSearchQueryString = query => ({
    query,
    type: actions.UPDATE_TCSM_SEARCH_QUERY_STRING
});

export const updateSearchByDropDown = key => ({
    key,
    type: actions.UPDATE_TCSM_SEARCH_BY
});

export const onSearch = (searchBy, query) =>
    dispatch => {

        if (mapClaimValidation(searchBy, query)) {

            dispatch(routerActions.push(mapSearchRoutes(searchBy, query)));

        } else {

            const translatedErrorMessage = translate(mapValidationErrorMessages(searchBy));

            errorAlertBar(createErrorObject(translatedErrorMessage));

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/search.js